import React from "react"

/**
 * TrialEndedBanner shows for admin users when an account's trial has ended.
 *
 * IF THIS COMPONENT IS UPDATED, UPDATE THE RAILS PARTIAL AT app/views/layouts/_trial_ended.html.erb
 *
 */
export function TrialEndedBanner() {
  return (
    <div className="alert alert--banner alert--admin">
      <span className="label">admin</span>
      The trial has ended for this account and they do not have access until
      adding a credit card.
    </div>
  )
}
